import { MMSUnit, MMS_ADDON_SKU, MMS_BASE_UNIT_SKU } from '@/js/pages/product/rackbuilder/utils/mms-utils/mms-constants'
import { getMassStorageEmailLayout } from '@/js/pages/product/rackbuilder/utils/ms-utils/ms-unit-label'
import type { CustomProductVariant } from '../types'

export const monsterMassStorageVariant: CustomProductVariant = {
  id          : 'monster-mass-storage',
  featureFlag : 'enable-monster-mass-storage',

  matches: (product, groupProduct) => {
    const sku = product?.sku
    const groupSku = groupProduct?.sku

    return (!!sku && MMSUnit.includes(sku)) || (!!groupSku && MMSUnit.includes(groupSku))
  },

  skuSets: {
    allSkus              : MMSUnit,
    // Narrower than `allSkus` — deliberately excludes the grouped SKU (MMSUnit's 3rd member).
    itemSkus             : [MMS_BASE_UNIT_SKU, MMS_ADDON_SKU],
    mainSkus             : [MMS_BASE_UNIT_SKU],
    qtyExcludedSkus      : MMSUnit,
    addCountExcludedSkus : [MMS_ADDON_SKU],
  },

  // Bolt-kit hardware lines carry hardwareCount and must still count toward cart qty despite their otherwise-excluded unit sku.
  readmitFromQty : (item) => !!item.metadata?.hardwareCount,
  // MMS joins its addon/hardware siblings via metadata.recipe.
  purchaseKey    : (item) => item.metadata?.recipe,
  emailLayout    : getMassStorageEmailLayout,
}
